$(document).ready(function() {

    // TODO: (Refactor) Transfer functions from window.util to here

    ub.utilities = {

        maintenanceMessage: function () {

            var template = $('#m-maintenance-message').html();
            var data = { date: ''};
            var markup = Mustache.render(template, data);

            var dialog = bootbox.dialog({
                title: 'Maintenance Schedule',
                message: markup,
            });

            dialog.init(function() {});

        },

        warn: function (msg, type, user) {
            // TODO: Persist / Log warnings to storage
            // TODO: (Refactor) Funnel all warnings through here

            if (ub.config.app_env !== "production") {
                console.warn(msg);
            }
        },

        error: function (msg, type, user) {

            // TODO: Persist / Log error to storage
            // TODO: (Refactor) Funnel all errors through here
            if (ub.config.app_env !== "production") {
                console.trace();
                console.error(msg);
            }

        },

        proggError: function (msg, type, user) {

            // Programming Error Message should be funneled using this

            // TODO: Persist / Log error to storage
            // TODO: (Refactor) Funnel all errors through here

            
            if (ub.config.app_env !== "production") {
                console.trace();
                console.error(msg);
            }

        },

        info: function (msg, type, user) {
            // TODO: Persist / Log to storage
            // TODO: (Refactor) Funnel all info messages through here
            if (ub.config.app_env !== "production") {
                console.info(msg);
            }
        },

        actionLog: function (msg, type, user) {

            // TODO: Persist / Log to storage
            // TODO: (Refactor) Funnel all user action here ...
            if (ub.config.app_env !== "production") {
                console.info(msg);
            }
        },

        buildTemplateString: function (templateID, data) {
            var template = $(templateID).html();
            var markup = Mustache.render(template, data);

            return markup;
        },

        // Safe Clone JS Object
        cloneObject: function (object) {
            return JSON.parse(JSON.stringify(object));
        },

        getJSON: function(url, successHandler, errorHandler) {
            var xhr = typeof XMLHttpRequest != 'undefined'
                ? new XMLHttpRequest()
                : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open('get', url, true);
            xhr.onreadystatechange = function() {
                var status;
                var data;
                // https://xhr.spec.whatwg.org/#dom-xmlhttprequest-readystate
                if (xhr.readyState == 4) { // `DONE`
                    status = xhr.status;
                    if (status == 200) {
                        data = JSON.parse(xhr.responseText);
                        successHandler && successHandler(data);
                    } else {
                        errorHandler && errorHandler(status);
                    }
                }
            };
            xhr.send();
        },

        postJSON: function(url, params, successHandler, errorHandler) {
            var xhr = typeof XMLHttpRequest != 'undefined'
                ? new XMLHttpRequest()
                : new ActiveXObject('Microsoft.XMLHTTP');

            xhr.withCredentials = true;
            xhr.open('post', url, true);

            xhr.onreadystatechange = function() {
                var status;
                var data;
                // https://xhr.spec.whatwg.org/#dom-xmlhttprequest-readystate
                if (xhr.readyState == 4) { // `DONE`
                    status = xhr.status;
                    if (status == 200) {
                        data = JSON.parse(xhr.responseText);
                        successHandler && successHandler(data);
                        console.trace()
                    } else {
                        errorHandler && errorHandler(status);
                    }
                }
            };
            var data = JSON.stringify(params);
            xhr.send(data);
        },

        ajaxPostJSON: function(headers, url, data, successHandler, errorHandler) {
            $.ajaxSetup({
                headers: headers
            });

            $.ajax({
                url: url,
                data: data,
                type: "POST",
                dataType: 'json',
                success: successHandler,
                error: errorHandler
            });
        },

        ajaxGetJSON: function(url, successHandler, errorHandler) {
            $.ajax({
                url: url,
                type: "GET",
                dataType: 'json',
                success: successHandler,
                error: errorHandler
            });
        },

        // Parse single qoute &#039; appearing in place of ' (single qoutes),
        // normally used when filtering collections using the Neck Option and Block Pattern Fields

        domParserDecoder: function (str) {

            var parser = new DOMParser;
            var dom = parser.parseFromString(
                '<!doctype html><body>' + str,
                'text/html');
            var decodedString = dom.body.textContent;

            return decodedString;

        },

        underscoreToWhitespace: function(haystack) {
            haystack.replace('left_', '').replace('right_', '');
            return haystack.replace(/_/g, ' ');
        },

        titleCase: function(str) {
            return str.toLowerCase().split(' ').map(function(word) {
                if (!word[0]) return;
                return word.replace(word[0], word[0].toUpperCase());
            }).join(' ');
        },

        base64ToBlob: function(base64ImageContent, mime) {
            mime = mime || '';
            var sliceSize = 1024;
            var byteChars = atob(base64ImageContent);
            var byteArrays = [];

            for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
                var slice = byteChars.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: mime});
        },

        notifyMe: function(message, type, sec = 5000, pos = 'top-right') {
            UIkit.notification({
                message: message,
                status: type,
                pos: pos,
                timeout: sec
            });
        },

        changeAssetUrl: function(filename) {
            var newfilename;

            if (_.isUndefined(filename) || _.isNull(filename)) return filename;

            if (filename.includes(ub.config.S3_URL)) {
                newfilename = filename.replace(ub.config.S3_URL, ub.config.materialsUrl);
            }
            
            if (filename.includes(ub.config.S3_URL2)) {
                newfilename = filename.replace(ub.config.S3_URL2, ub.config.materialsUrl);
            }
            
            if (filename.includes(ub.config.S3_URL_QX)) {
                newfilename = filename.replace(ub.config.S3_URL_QX, ub.config.materialsUrl);
            }

            if (_.isUndefined(newfilename)) {
                newfilename = filename;;
            }

            return newfilename
        },

        decimalToFraction: function(_decimal) {
            if (_decimal == parseInt(_decimal)) {
                return {
                    top: parseInt(_decimal),
                    bottom: 1,
                    display: parseInt(_decimal) + '/' + 1
                };
            } else {
                var top = _decimal.toString().includes(".") ? _decimal.toString().replace(/\d+[.]/, '') : 0;
                var bottom = Math.pow(10, top.toString().replace('-','').length);
                if (_decimal >= 1) {
                    top = +top + (Math.floor(_decimal) * bottom);
                }
                else if (_decimal <= -1) {
                    top = +top + (Math.ceil(_decimal) * bottom);
                }

                var x = Math.abs(ub.utilities.gcd(top, bottom));
                return {
                    top: (top / x),
                    bottom: (bottom / x),
                    display: (top / x) + '/' + (bottom / x)
                };
            }
        },

        gcd: function(a, b) {
            return (b) ? this.gcd(b, a % b) : a;
        },

        rowBlank: function(imageData, width, y) {
            for (var x = 0; x < width; ++x) {
                if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
            }

            return true;
        },

        columnBlank: function(imageData, width, x, top, bottom) {
            for (var y = top; y < bottom; ++y) {
                if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
            }

            return true;
        },

        trimCanvas: function(canvas, bottomAdjustment) {
            var self = this;
            var ctx = canvas.getContext("2d");
            var width = canvas.width;
            var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var top = 0, bottom, left = 0, right = imageData.width;

            if (typeof bottomAdjustment !== "undefined") {
                bottom = imageData.height + 50;
            } else {
                bottom = imageData.height;
            }

            while (top < bottom && self.rowBlank(imageData, width, top)) ++top;
            while (bottom - 1 > top && self.rowBlank(imageData, width, bottom - 1)) --bottom;
            while (left < right && self.columnBlank(imageData, width, left, top, bottom)) ++left;
            while (right - 1 > left && self.columnBlank(imageData, width, right - 1, top, bottom)) --right;

            var trimmed = ctx.getImageData(left, top, right - left, bottom - top);
            var copy = canvas.ownerDocument.createElement("canvas");
            var copyCtx = copy.getContext("2d");
            copy.width = trimmed.width;
            copy.height = trimmed.height;
            copyCtx.putImageData(trimmed, 0, 0);

            return copy;
        },

        trimPngFile: function(png, callback) {
            var canvas = document.createElement("canvas");
            canvas.width = 500;
            canvas.height = 150;

            var ctx = canvas.getContext("2d");
            var img = new Image();

            Jimp.read(png)
            .then(function (image) {
                image
                .resize(Jimp.AUTO, 150)
                .getBase64(Jimp.MIME_PNG, function (err, src) {
                    if (err) {
                        callback(png);
                    } else {
                        img.src = src;
                        img.onload = function() {
                            ctx.drawImage(img, 0, 0);
                            var trimvCanvas = ub.utilities.trimCanvas(canvas);
                            callback(trimvCanvas.toDataURL());
                        };
                    }
                });
            })
            .catch(function(err) {
                callback(png);
            });
        },

        trimMascot: function(png, width, height, callback) {
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            var ctx = canvas.getContext("2d");
            var img = new Image();

            Jimp.read(png)
            .then(function (image) {
                image
                .contain(width, height, Jimp.VERTICAL_ALIGN_MIDDLE)
                .resize(Jimp.AUTO, height, Jimp.RESIZE_BICUBIC)
                .getBase64(Jimp.MIME_PNG, function (err, src) {
                    if (err) {
                        callback(png);
                    } else {
                        img.src = src;
                        img.onload = function() {
                            ctx.drawImage(img, 0, 0);
                            var trimvCanvas = ub.utilities.trimCanvas(canvas, true);
                            callback(trimvCanvas.toDataURL());
                        };
                    }
                });
            })
            .catch(function(err) {
                callback(png);
            });
        }
    };

    /// Benchmarks

        // Uniform Pickers Loader

            ub.pickersDialog = undefined;

            ub.pickersStartTime = function () {

                if (ub.page !== "builder") { return; }

                ub.startTime = new Date();

                // var template = $('#m-loading-screen').html();
                // var data = {
                //     startTime: ub.startTime,
                //     title: 'Preparing Style List',
                //     logo: ub.branding.logoUrl
                // };

                // var markup = Mustache.render(template, data);

                // ub.pickersDialog = bootbox.dialog({
                //     message: markup,
                //     backdrop: true,
                //     className: 'loading-dialog-pickers',
                // });

                $('div.debug-panel').addClass('pickersLoader')

            }

        // End Uniform Pickers Loader



        var loadingDialog = undefined;

        ub.startTime = function () {

            ub.startTime = new Date();

            ub.utilities.info(ub.config.uniform_name + ' - ' + ub.config.sport);
            ub.utilities.info('');

            // var template = $('#m-loading-screen').html();
            // var data = {
            //     startTime: ub.startTime,
            //     title: '',
            //     uniformName: ub.config.uniform_name + ' - ' + ub.config.sport,
            //     logo: ub.branding.logoUrl
            // };

            // var markup = Mustache.render(template, data);

            // loadingDialog = bootbox.dialog({
            //     message: markup,
            //     backdrop: true,
            //     className: 'loading-dialog',
            // });

        }

        ub.getElapsedTime = function () {

            var dateNow = new Date();
            var timeDiff = dateNow - ub.startTime;

            // strip the ms
            // timeDiff /= 1000;

            // get seconds (Original had 'round' which incorrectly counts 0:28, 0:29, 1:30 ... 1:59, 1:0)
            var seconds = Math.round(timeDiff);

            seconds = (seconds / 1000);
            seconds = seconds.toFixed(4)
            seconds = seconds.toString().lpad('&nbsp;', 7);

            return seconds;

        }

        var b = '';
        ub.displayDoneAt = function (str) {

            if (ub.page !== "builder") { return; }

            var _line;
            var _class = '';
            var _consoleLine;
            var _a;
            var _nameString;

            if (str === 'Rendering awesomeness ...') {
                ub.funcs.addFunctionToAfterloadList(function() {
                    /// Hide loading after .5 sec done
                    setTimeout(function () {
                        $('div.debug-panel').fadeOut();
                    }, 500);
                });

                _line = str + " <strong class='light'>" +  ub.getElapsedTime() + ' secs.</strong>';

                _class = 'awesomeness';

            } else {

                _line = '[<strong class="light">' + ub.getElapsedTime() + ' sec.</strong> ]\t' + (typeof str !== "undefined" ? str + ' ' : '');

            }

            _consoleLine = _line.replace('&nbsp;', ' ');

            _consoleLine = _consoleLine.replace('<br />', '');
            _consoleLine = _consoleLine.replace('<strong>', '');
            _consoleLine = _consoleLine.replace('<strong class="light">', '');
            _consoleLine = _consoleLine.replace('</strong>', '');
            _consoleLine = _consoleLine.replace('class="light"', '');

            ub.utilities.info(_consoleLine);

            // Hide `Rendering awesomeness ...` loading info
            // _a = '<span class="load-line ' + _class + '">' + _line + '</span>'; 

            $('div.loading-messages').append(_a);

            _nameString = 'Loading ' + ub.config.uniform_name + ' [' + ub.config.sport + ']';

            if (ub.config.uniform_name  === "none" || ub.config.sport === "none") { _nameString = "Loading Pickers..."; }

            ub.updateDebugPanel('', _a, _nameString);

            $('span.load-line').fadeIn();

        }

        ub.funcs.closePickersDialog = function () {

            setTimeout(function(){
               $('div.debug-panel').fadeOut();
            }, 100);

        }

        ub.funcs.is_pts_signature = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts signature") !== -1;
        };

        ub.funcs.is_select_set_in = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("select set-in") !== -1;
        };

        ub.funcs.is_select_pant = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("select pant") !== -1;
        };

        ub.funcs.is_select_sleeveless = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("select sleeveless") !== -1;
        };

        ub.funcs.is_pts_raglan = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts raglan") !== -1;
        };

        ub.funcs.is_new_pts_pant = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts pant") !== -1;
        };

        ub.funcs.is_pts_sleeveless = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts sleeveless") !== -1;
        };

        ub.funcs.is_pts_pro_select = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts pro select") !== -1;
        };

        ub.funcs.is_pts_select = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts select") !== -1;
        };

        ub.funcs.is_pts_signature_pant = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts signature pant") !== -1;
        };

        ub.funcs.is_pts_pro_select_pant = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts pro select pant") !== -1;
        };

        ub.funcs.is_pts_select_pant = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts select pant") !== -1;
        };

        ub.funcs.is_pts_pant = function() {
            if (ub.funcs.is_pts_select_pant() || ub.funcs.is_select_pant() || ub.funcs.is_pts_pro_select_pant() || ub.funcs.is_new_pts_pant() || ub.funcs.is_pts_signature_pant()) {
                return true;
            }
        }

        ub.funcs.is_pts_cage_jacket = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts cage jacket") !== -1;
        };

        ub.funcs.is_pts_hoodie = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts hoodie") !== -1;
        };

        ub.funcs.is_pts_sock = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("pts sock") !== -1;
        };

        ub.funcs.is_sublimated = function() {
            return ub.config.uniform_application_type === "sublimated";
        };

        ub.funcs.is_twill = function() {
            return ub.config.uniform_application_type === "tackle_twill";
        };

        ub.funcs.isBaseBall = function() {
            return ub.config.sport === "Baseball";
        };

        ub.funcs.is_upper = function() {
            return ub.config.type === "upper";
        };

        ub.funcs.is_lower = function() {
            return ub.config.type === "lower";
        };

        ub.funcs.is_sleeveless = function() {
            return ub.config.blockPattern.toLowerCase().indexOf("sleeveless") !== -1;
        };

        ub.funcs.isPlayer = function() {
            let { id, type } = ub.user;
            if (typeof type !== "undefined" && id !== null) {
                return type.toLowerCase() === "player";
            }

            return false;
        }

        ub.funcs.isDealer = function() {
            let { id, type, authorization_level } = ub.user;
            if (typeof type !== "undefined" && id !== null) {
                var rch_authorization = ["blank only", "blank & decoration", "blank && decoration", "blank and decoration"];
                return (type.toLowerCase() === "dealer" && _.contains(rch_authorization, authorization_level.toLowerCase()));
            }

            return false;
        }

        ub.funcs.isTeam = function() {
            let { id, type, authorization_level } = ub.user;
            if (typeof type !== "undefined" && id !== null) {
                return (type.toLowerCase() === "dealer" && authorization_level.toLowerCase() === "team");
            }

            return false;
        }

        ub.funcs.isLoggedIn = function() {
            return ub.user;
        }

        ub.funcs.getUniformType = function() {
            var uniform_type = "";

            if (ub.funcs.is_pts_cage_jacket()) {
                uniform_type = "Jacket";
            } else if (ub.funcs.is_pts_sock()) {
                uniform_type = "Sock";
            } else if (ub.funcs.is_pts_hoodie()) {
                uniform_type = "Hoodie";
            } else if (ub.funcs.is_pts_signature_pant() || ub.funcs.is_pts_pro_select_pant() || ub.funcs.is_new_pts_pant() || ub.funcs.is_pts_select_pant() || ub.funcs.is_select_pant()) {
                uniform_type = "Pant";
            } else {
                uniform_type = "Jersey";
            }

            return uniform_type;
        }

        ub.funcs.showNotification = function(message, status, duration = 4000) {
            UIkit.notification({
                message: message,
                status: status,
                pos: 'top-right',
                timeout: duration
            });
        }

    /// End Benchmarks

    /// After Load Scripts

        ub.afterLoadScripts = function () {

            if (ub.config.app_env === "local") {
                ub.utilities.info('Local environment detected, skipping afterload scripts.');
            } else {
               $.getScript('/uniform-builder/js/uniform-builder-after-load-scripts.js');
            }

        }

    /// End After Load Scripts


});